import fetcher from './fetcher';
import { API_ENDPOINTS } from '../config';

export default async function getConfigByType({ id, urlParams }) {
	const config = await fetcher({ path: `${API_ENDPOINTS.config}${id}/`.replace(/\/\//g, "/"), urlParams });
	return config;
}
